export default __webpack_public_path__ + "static/lampa_polimeryzacyjna-c52adbacc7329bf2a37ae43952d03e8e.jpg";